import { render, staticRenderFns } from "./indexCSG.vue?vue&type=template&id=943bd112"
import script from "./indexCSG.vue?vue&type=script&lang=js"
export * from "./indexCSG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('943bd112')) {
      api.createRecord('943bd112', component.options)
    } else {
      api.reload('943bd112', component.options)
    }
    module.hot.accept("./indexCSG.vue?vue&type=template&id=943bd112", function () {
      api.rerender('943bd112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/account/components/viewForm/indexCSG.vue"
export default component.exports